// extracted by mini-css-extract-plugin
export default {"header":"legal_header__pf0Al"};